<template>
<div class="user-widget" v-if="!loading">
  <a href="" @click.prevent="loginPopup=true" v-if="!loggedInUser">Login</a>
  <template v-else>
    <a :href="themeData.base.pageUrls.profile">Profile</a>
    <a href="" @click.prevent="doLogout">Logout</a>
  </template>
  <popup v-model:open="loginPopup">
    <template v-slot:header>
      Login
    </template>
    <form @submit.prevent="doLogin">
      <input placeholder="email" type="text" v-model="loginForm.username" name="email" />
      <input placeholder="password" type="password" v-model="loginForm.password" name="password" />
      <button>Login</button>
      <p v-if="loginError" class="error">{{ loginError }}</p>
    </form>
  </popup>
</div>
</template>

<script>
import UserWidget from './UserWidget.js';
export default UserWidget;
</script>

